import { render, staticRenderFns } from "./AssetModal.vue?vue&type=template&id=fec56474&"
import script from "./AssetModal.vue?vue&type=script&lang=js&"
export * from "./AssetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports